"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomepageSlide10 = exports.HomepageSlide10 = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
class HomepageSlide10 extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
    <style>
      :host {
        display: grid;
        grid-template-columns: 1fr 1fr;
        box-sizing: border-box;
        width: 100%;
        max-width: var(--slide-max-width, 100%);
        margin: 5rem auto;
      }
      
      div.form {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 1.2rem;
        gap: 0.2rem;
      }
      
      div.form div.title {
        font-size: 1.8rem;
        font-weight: bold;
        margin-bottom: 1rem;
      }
      
      div.form div.item-name {
        font-size: 0.8rem;
      }
      
      div.form input {
        width: 100%;
        border: solid silver 0.5px;
        border-radius: 2rem;
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
      }
      
      div.form textarea {
        width: 100%;
        aspect-ratio: 3 / 1;
        border: solid silver 0.5px;
        border-radius: 0.8rem;
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
      }
      
      div.form button.send-message {
        border: none;
        background: #d4ebff;
        padding: 0.6rem;
        border-radius: 0.5rem;
      }
      
      div.map {
        display: flex;
        align-items: center;
        padding: 0.5rem;
        box-sizing: border-box;
      }
      
      div.map img {
        width: 100%;
        height: auto;
      }
      
      @media (max-width: 600px) {
        :host {
          display: flex;
          flex-direction: column;
          padding: 1rem;
          box-sizing: border-box;
          margin: 1rem auto;
        }
        div.form {
          padding: unset;
        }
        div.form button.send-message {
          width: 100%;
        }
        div.map {
          margin-top: 0.5rem;
        }
      }
    </style>
    <div class="form">
      <div class="title">Get In Touch</div>
      <div class="name item-name">Name</div>
      <div class="name-input"><input type="text" /></div>
      <div class="phone-number item-name">Phone Number</div>
      <div class="phone-number-input"><input type="tel" /></div>
      <div class="Message item-name">Message</div>
      <div class="message-input"><textarea></textarea></div>
      <div class="send-message-btn-container">
        <button class="send-message">Send</button>
      </div>
    </div>
    <div class="map">
      <img src="/files/assets/images/slide-10-map.png" />
    </div>`;
    }
}
exports.HomepageSlide10 = HomepageSlide10;
const defineHomepageSlide10 = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, HomepageSlide10);
};
exports.defineHomepageSlide10 = defineHomepageSlide10;
